import React, { useState } from 'react';
import {
  ImageBackground,
  StyleSheet,
  Text as NativeText,
  TouchableOpacity,
  View,
} from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
import { LinearGradient } from 'expo-linear-gradient';
import { useSelector } from 'react-redux';

import FooterLanding from '../../components/footerComponentLanding/customFooter';
import TextInputComponent from '../../components/textinput/TextInputComponent';
import MainDrawerMenu from '../hello/MainDrawer';
import { Header } from '../hello/header';
import rightImg from '../../assets/images/forgotImage.png';
import ajax from '../../helpers/ajaxHelper';
import getPlatformType from '../../helpers/helpers';
import { EmailValidation } from '../../helpers/validation';
import Urls from '../../services/Urls';
import { showSuccesToast } from '../tenants/tenantOnboarding/helpers';

const forgotTitle = 'Forgot Password';
const forgotSubtitle =
  'Enter your email address and if it exists in our system, we will send you instructions to reset your password.';
const forgotPrimaryLabel = 'Submit';
const forgotSecondaryLabel = 'Back to Login';
const forgotHeroPrompt = 'Remembered your password?';
const forgotHeroPromptAction = 'Login';
const forgotHeroEyebrow = 'Fast account recovery';
const forgotHeroTitle = 'Get back into your landlord workspace quickly';
const forgotHeroText =
  'Reset access with a simple email step and return to managing your properties, reminders and tenant activity.';

const forgotHighlights = [
 
];

const ForgotPasswordScreen = ({ navigation }) => {
  const layoutType = getPlatformType();
  const isPhone = layoutType === 'phone';
  const userToken = useSelector((state) => state?.AppReducer?.token);
  const [openDrawer, setDrawer] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');

  const forgotAPICall = () => {
    const requestBody = {
      email,
    };

    ajax
      .post(Urls.ForgotPassword, requestBody)
      .then(({ data }) => {
        if (data.status) {
          showSuccesToast(data?.data);
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const forgotPasswordValidation = () => {
    const emailValidate = EmailValidation(email);
    if (emailValidate.status) {
      forgotAPICall();
    } else {
      setEmailError(emailValidate?.status ? '' : emailValidate?.msg);
    }
  };

  const formContent = (
    <>
      <NativeText style={[styles.publicTitle, isPhone && styles.mobilePublicTitle]}>
        {forgotTitle}
      </NativeText>
      <NativeText style={[styles.publicSubtitle, isPhone && styles.mobilePublicSubtitle]}>
        {forgotSubtitle}
      </NativeText>

      <View style={[styles.publicInputsWrap, isPhone && styles.mobileInputsWrap]}>
        <TextInputComponent
          error={emailError}
          title="Email Address"
          onChangeText={(value) => {
            setEmail(value);
            setEmailError('');
          }}
          colored
        />
      </View>

      <View style={styles.publicFooterRow}>
        <TouchableOpacity
          onPress={() => navigation.navigate('login')}
          style={isPhone ? styles.mobileSecondaryAction : styles.desktopSecondaryButton}
          activeOpacity={0.85}
        >
          <NativeText
            style={isPhone ? styles.mobileSecondaryActionText : styles.desktopSecondaryButtonText}
          >
            {forgotSecondaryLabel}
          </NativeText>
        </TouchableOpacity>

        {!isPhone && (
          <LinearGradient
            colors={['#2C8EF4', '#5C59E8']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={styles.primaryAction}
          >
            <TouchableOpacity
              onPress={forgotPasswordValidation}
              style={styles.primaryActionTouch}
              activeOpacity={0.9}
            >
              <NativeText style={styles.primaryActionText}>{forgotPrimaryLabel}</NativeText>
            </TouchableOpacity>
          </LinearGradient>
        )}
      </View>

      {isPhone && (
        <>
          <LinearGradient
            colors={['#2C8EF4', '#5C59E8']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={[styles.primaryAction, styles.primaryActionMobile]}
          >
            <TouchableOpacity
              onPress={forgotPasswordValidation}
              style={styles.primaryActionTouch}
              activeOpacity={0.9}
            >
              <NativeText style={styles.primaryActionText}>{forgotPrimaryLabel}</NativeText>
            </TouchableOpacity>
          </LinearGradient>

          <View style={styles.mobileHighlightList}>
            {forgotHighlights.map((item) => (
              <View key={item} style={styles.mobileHighlightItem}>
                <View style={styles.mobileHighlightDot} />
                <NativeText style={styles.mobileHighlightText}>{item}</NativeText>
              </View>
            ))}
          </View>
        </>
      )}
    </>
  );

  const publicForgotContent = isPhone ? (
    <View style={styles.mobilePublicWrap}>
      <View style={styles.mobileFormCard}>{formContent}</View>
    </View>
  ) : (
    <View style={styles.publicShell}>
      <View style={styles.publicCard}>
        <View style={styles.publicLeftPanel}>
          <View style={styles.publicFormCardInner}>{formContent}</View>
        </View>

        <ImageBackground source={rightImg} style={styles.publicRightPanel} imageStyle={styles.publicRightImage}>
          <LinearGradient
            colors={['rgba(27,42,78,0.92)', 'rgba(76,74,219,0.78)', 'rgba(204,88,227,0.62)']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.publicOverlay}
          >
            <View style={styles.publicTopAction}>
              <NativeText style={styles.publicTopActionText}>{forgotHeroPrompt}</NativeText>
              <TouchableOpacity
                onPress={() => navigation.navigate('login')}
                style={styles.secondaryAction}
                activeOpacity={0.9}
              >
                <NativeText style={styles.secondaryActionText}>{forgotHeroPromptAction}</NativeText>
              </TouchableOpacity>
            </View>

            <View style={styles.publicHeroCopy}>
              <NativeText style={styles.publicHeroEyebrow}>{forgotHeroEyebrow}</NativeText>
              <NativeText style={styles.publicHeroTitle}>{forgotHeroTitle}</NativeText>
              <NativeText style={styles.publicHeroText}>{forgotHeroText}</NativeText>

              <View style={styles.desktopHighlightList}>
                {forgotHighlights.map((item) => (
                  <View key={item} style={styles.desktopHighlightItem}>
                    <View style={styles.desktopHighlightDot} />
                    <NativeText style={styles.desktopHighlightText}>{item}</NativeText>
                  </View>
                ))}
              </View>
            </View>
          </LinearGradient>
        </ImageBackground>
      </View>
    </View>
  );

  if (!userToken) {
    return (
      <View style={styles.screen}>
        <Header setDrawer={() => setDrawer(true)} />
        <View style={styles.content}>{publicForgotContent}</View>
        <FooterLanding navigation={navigation} />
        <Modal
          isVisible={openDrawer}
          animationIn="slideInRight"
          animationOut="slideOutRight"
          animationInTiming={300}
          animationOutTiming={300}
          coverScreen={false}
          hasBackdrop={false}
          backdropOpacity={0}
          onBackdropPress={() => setDrawer(false)}
          style={{ margin: 0, width: '100%', right: 0 }}
        >
          <View style={styles.drawerWrap}>
            <MainDrawerMenu setDrawer={setDrawer} />
          </View>
        </Modal>
      </View>
    );
  }

  return <View style={styles.screen}>{publicForgotContent}</View>;
};

export default ForgotPasswordScreen;

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: '#F7F9FC',
  },
  content: {
    flex: 1,
  },
  publicShell: {
    flex: 1,
    paddingHorizontal: 28,
    paddingVertical: 26,
    backgroundColor: '#F7F9FC',
  },
  publicCard: {
    flex: 1,
    minHeight: 680,
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#E6EAF2',
    shadowColor: '#101828',
    shadowOpacity: 0.08,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 12 },
    elevation: 4,
    flexDirection: 'row',
  },
  publicLeftPanel: {
    width: '48%',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 40,
    paddingVertical: 36,
  },
  publicFormCardInner: {
    width: '100%',
    maxWidth: 500,
    paddingVertical: 12,
  },
  publicTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
    fontSize: 44,
    lineHeight: 52,
    color: '#1B2559',
    maxWidth: 420,
  },
  publicSubtitle: {
    fontFamily: 'roboto-light',
    fontSize: 17,
    lineHeight: 28,
    color: '#667085',
    marginTop: 14,
    maxWidth: 430,
  },
  publicInputsWrap: {
    marginTop: 22,
    gap: 12,
  },
  publicFooterRow: {
    marginTop: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  primaryAction: {
    minWidth: 140,
    height: 54,
    borderRadius: 14,
    overflow: 'hidden',
    shadowColor: '#4258DB',
    shadowOpacity: 0.24,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 8 },
    elevation: 3,
  },
  primaryActionTouch: {
    minWidth: 140,
    height: 54,
    paddingHorizontal: 28,
    justifyContent: 'center',
    alignItems: 'center',
  },
  primaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 20,
    color: '#FFFFFF',
  },
  desktopSecondaryButton: {
    paddingVertical: 12,
    paddingHorizontal: 8,
  },
  desktopSecondaryButtonText: {
    fontFamily: 'poppins-medium',
    fontSize: 15,
    lineHeight: 22,
    color: '#4258DB',
  },
  publicRightPanel: {
    width: '52%',
    minHeight: 680,
    justifyContent: 'space-between',
    backgroundColor: '#25125F',
  },
  publicRightImage: {
    resizeMode: 'cover',
  },
  publicOverlay: {
    flex: 1,
    paddingHorizontal: 38,
    paddingVertical: 34,
    justifyContent: 'space-between',
  },
  publicTopAction: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  publicTopActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 20,
    lineHeight: 28,
    color: '#FFFFFF',
    marginRight: 18,
  },
  secondaryAction: {
    height: 50,
    paddingHorizontal: 28,
    borderRadius: 14,
    borderWidth: 2,
    borderColor: 'rgba(255,255,255,0.9)',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  secondaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 22,
    color: '#FFFFFF',
  },
  publicHeroCopy: {
    maxWidth: 480,
    paddingBottom: 12,
  },
  publicHeroEyebrow: {
    fontFamily: 'poppins-medium',
    fontSize: 14,
    lineHeight: 20,
    color: '#D5D9FF',
    marginBottom: 14,
  },
  publicHeroTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
    fontSize: 42,
    lineHeight: 52,
    color: '#FFFFFF',
    maxWidth: 460,
  },
  publicHeroText: {
    fontFamily: 'roboto-light',
    fontSize: 17,
    lineHeight: 28,
    color: 'rgba(255,255,255,0.9)',
    marginTop: 16,
    maxWidth: 430,
  },
  desktopHighlightList: {
    marginTop: 28,
  },
  desktopHighlightItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 14,
  },
  desktopHighlightDot: {
    width: 10,
    height: 10,
    borderRadius: 999,
    backgroundColor: '#CC58E3',
    marginTop: 9,
    marginRight: 12,
  },
  desktopHighlightText: {
    flex: 1,
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 24,
    color: '#FFFFFF',
  },
  mobilePublicWrap: {
    flex: 1,
    paddingHorizontal: 18,
    paddingTop: 18,
    paddingBottom: 24,
    backgroundColor: '#F7F9FC',
  },
  mobileFormCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E6EAF2',
    padding: 22,
    shadowColor: '#101828',
    shadowOpacity: 0.06,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 2,
  },
  mobilePublicTitle: {
    fontSize: 34,
    lineHeight: 42,
    color: '#1E2A4A',
  },
  mobilePublicSubtitle: {
    fontSize: 16,
    lineHeight: 26,
  },
  mobileInputsWrap: {
    marginTop: 20,
  },
  primaryActionMobile: {
    width: '100%',
    marginTop: 10,
  },
  mobileSecondaryAction: {
    width: '100%',
    height: 50,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#D9E3FB',
    backgroundColor: '#F8FBFF',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileSecondaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 20,
    color: '#1B2A4E',
  },
  mobileHighlightList: {
    marginTop: 18,
  },
  mobileHighlightItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  mobileHighlightDot: {
    width: 8,
    height: 8,
    borderRadius: 999,
    backgroundColor: '#CC58E3',
    marginTop: 8,
    marginRight: 10,
  },
  mobileHighlightText: {
    flex: 1,
    fontFamily: 'roboto-light',
    fontSize: 14,
    lineHeight: 22,
    color: '#667085',
  },
  drawerWrap: {
    marginLeft: 'auto',
    width: getPlatformType() === 'phone' ? '100%' : '50%',
    height: '100%',
    backgroundColor: 'transparent',
  },
});
